import React from "react";
import { Navigate } from "react-router-dom";
import { useIsTenantAdmin } from "../../hooks/useIsTenantAdmin";

/** Guards platform-STAFF routes. A tenant-admin principal (CUSTOMER carrying a `tid`
 *  claim) must never reach STAFF surfaces (partner-management, users, references,
 *  ebarimt, billing, tenant) — they are bounced to their own /my-billing. Real
 *  platform STAFF (no tid) pass through unchanged. This is the route-level counterpart
 *  to nav hiding: it blocks deep-links, not just menu visibility. */
export function RequireStaff({ children }: { children: React.ReactNode }) {
  return useIsTenantAdmin() ? <Navigate to="/my-billing" replace /> : <>{children}</>;
}
